export default __webpack_public_path__ + "static/media/hospitals.6bd76921.svg";